import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21a12066"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-nologin-main" }
const _hoisted_2 = { class: "mxa-nologin-main-explanation" }
const _hoisted_3 = { "data-test": "area_desc_msg1" }
const _hoisted_4 = { "data-test": "area_desc_msg2" }

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import BaseButton from '@/components/common/button/BaseButton.vue'
import ErrorMessage from '@/components/common/screen/ErrorMessage.vue'
import * as log from '@/model/util/log/Logger'
import {
  initDom,
  stateUserEntryAuthSend,
  userEntryAuthSend,
  useErrorMsg,
} from '@/model/components/users/userEntryAuthSend'
import RegisterStepbar from '@/components/main/nologin/RegisterStepbar.vue'
import NologinTitle from '@/components/main/nologin/NologinTitle.vue'
import EmailDisp from '@/components/common/screen/EmailDisp.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EntryAuthSend',
  props: {
  // ユーザー名
  username: {
    type: String,
    default: undefined,
  },
  // 登録種別
  type: {
    type: String,
    default: undefined,
  },
  // リダイレクト
  redirect: {
    type: String,
    default: undefined,
  },
  // ダウンロードキー
  downloadKey: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

log.trace('EntryAuthSend setup start.')

// プロパティ定義


// 状態
const state = stateUserEntryAuthSend(props)
const store = useStore()
const router = useRouter()
const errorState = useErrorMsg()

log.debug(`EntryAuthSend props: ${JSON.stringify(props)}, state: ${JSON.stringify(state)}`)
// onMountedの登録
onMounted(async () => {
  log.trace('EntryAuthSend onMounted start.')
  // F5等でusernameが設定されていない場合はTOP画面に遷移
  await initDom(state, store, router)
  log.trace('EntryAuthSend onMounted end.')
})
/**
 * ワンタイムパスワード送信ボタンクリック
 */
const onclick = async () => {
  log.trace('EntryAuthSend onclick start.')
  // api送信の実施
  await userEntryAuthSend(state, store, router, errorState)
  log.trace('EntryAuthSend onclick end.')
}
log.trace('EntryAuthSend setup end.')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RegisterStepbar, {
      active: 2,
      type: props.type
    }, null, 8, ["type"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(NologinTitle, {
        "is-entry": true,
        type: props.type
      }, null, 8, ["type"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('body.entry.message.send1')), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('body.entry.message.send2')), 1)
      ]),
      _createVNode(EmailDisp, {
        mail: props.username
      }, null, 8, ["mail"]),
      _createVNode(ErrorMessage, { error: _unref(errorState) }, null, 8, ["error"]),
      _createVNode(BaseButton, {
        loading: _unref(state).loading,
        isDisabled: _unref(state).loading,
        label: _ctx.$t('body.entry.button.issue.title'),
        onButtonClick: onclick
      }, null, 8, ["loading", "isDisabled", "label"])
    ])
  ], 64))
}
}

})